import * as React from 'react';
import { CalendarViewMode } from '../redux-state/interfaces/calendar-settings';
import { CalendarViewToggleProps } from './calendar-view-toggle';


const CalendarModeToggleView: React.StatelessComponent<CalendarViewToggleProps> = props => {
    return (
        <div className="ace-cal-toggles ace-cal-subnav-item">
            <button type="button" className="btn-pill ace-cal-filters-pill ace-cal-filters-toggle" disabled={props.calendarMode === CalendarViewMode.GRID} onClick={() => props.setToGrid(props.currentDate, props.startMonth)}>
                <svg className="svg-icon" aria-hidden="true" focusable="false">
                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref={`#icon-grid-view`} />
                </svg>
                {props.text.gridViewModeButtonText}
            </button>
            <button type="button" className="btn-pill ace-cal-filters-pill  ace-cal-filters-toggle" disabled={props.calendarMode === CalendarViewMode.LIST} onClick={() => props.setToList(props.currentDate, props.startMonth)}>
                <svg className="svg-icon" aria-hidden="true" focusable="false">
                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref={`#icon-list-view`} />
                </svg>
                {props.text.listViewModeButtonText}
            </button>
        </div>
    );
}

export default CalendarModeToggleView;